import { styled as e } from "styled-components";
import { Colors as r } from "../../styles/colors/index.js";
import { CaptionHeavy as t } from "../../styles/typography/index.js";
import { Theme as o, DarkNinjaThemeQuery as i, LightNinjaThemeQuery as n } from "../../styles/themes/index.js";
const d = e.button`
  ${t}
  display: flex;
  align-items: center;
  background-color: rgb(${o.colors.Juliet});
  color: rgb(${o.colors.Brand});
  padding-right: 16px;

  &:hover {
    color: rgb(${r.Tangerine});
    ${i} {
      color: rgb(${r.Bittersweet});
    }
    ${n} {
      color: rgb(${r.Gray});
    }
  }

  &:disabled {
    color: rgb(${o.colors.Golf});
  }

  i {
    margin-right: 4px;
    margin-left: 4px;
  }
`, g = e.div`
  border: 2px dashed rgb(${r.Gray});
  padding: 6px 0px 6px 16px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: rgb(${o.colors.Alpha});
  background-color: rgb(${o.colors.Juliet});
  overflow: hidden;
  white-space: nowrap;
`, s = e.div`
  ${t}
  max-width: 180px;
`;
export {
  d as CopyButtonBadge,
  g as CopyButtonContainer,
  s as CopyButtonText
};
